import React, { useEffect, useState } from 'react'
import { PropTypes } from 'prop-types'

import './style.scss'

export const PillarGoals = ({ goals = [], goalTag = '', onSelectGoal = () => {}, id = null, pillarSelected = '' }) => {
    const [filteredGoals, setFilteredGoals] = useState([])
    useEffect(() => {
        if (goals[pillarSelected]) {
            setFilteredGoals(goals[pillarSelected]?.answers)
        }
    }, [goals])

    const allButtons = filteredGoals.length ? filteredGoals : []

    const isSelected = tag => tag === goalTag

    return (
        <div className="pillarGoalsComponent">
            <div className="buttonsContainer">
                {allButtons.map(goal => (
                    <div key={goal.id} onClick={() => onSelectGoal(goal)} className={`goalButton ${!!isSelected(goal.tag) ? 'selected' : ''}`}>
                        <p> {goal.text}</p>
                    </div>
                ))}
            </div>
        </div>
    )
}

PillarGoals.propTypes = {
    onSelectGoal: PropTypes.func.isRequired,
}
